import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = {
  class: "mx-1 navbar-collapse flex justify-content-end collapse order-4 order-md-2",
  id: "user-dropdown"
}
const _hoisted_3 = { class: "navbar-nav flex-row" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "mx-1 nav-item order-2 order-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BellNotification = _resolveComponent("BellNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: "nav-link",
            href: _ctx.routes.DASHBOARD
          }, "Dashboard", 8, _hoisted_5)
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("a", {
            class: "nav-link btn-logout",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
            href: "javascript:void(0)"
          }, "Sign Out")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_BellNotification, { ref: "bell" }, null, 512)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("button", {
      class: "ml-1 navbar-toggler d-md-flex order-3 order-md-4",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#user-dropdown",
      "aria-controls": "user-dropdown",
      "aria-expanded": "false",
      "aria-label": "Toggle user dropdown"
    }, [
      _createElementVNode("span", { class: "p-1 fa fa-bars" })
    ], -1))
  ]))
}